import { mergeStyles, Stack } from "@fluentui/react";
import { useEffect, useState } from "react";
import MediaQuery from "react-responsive";
import { Breakpoint, GetBreakpoint, BreakpointType } from "./ContainerFluid";

export const containerStyles = mergeStyles([{
    width: '100dvw',
    height: 'calc(100dvh - 51px)',
    padding: '.875rem',
    position: 'absolute',
    top: '51px',
    fontFamily: 'Nunito',
    overflowY: 'auto'
}]);
export const containerStylesSM = mergeStyles([{
    width: '100dvw',
    height: 'calc(100dvh - 51px)',
    padding: '.875rem',
    position: 'absolute',
    top: '51px',
    left: '50%',
    transform: 'translateX(-50%)',
    fontFamily: 'Nunito',
    overflowY: 'auto'
}]);

export const containerStylesMD = mergeStyles([{
    width: '95dvw',
    height: 'calc(100dvh - 51px)',
    padding: '.875rem',
    position: 'absolute',
    top: '51px',
    left: '50%',
    transform: 'translateX(-50%)',
    fontFamily: 'Nunito',
    overflowY: 'auto'
}]);

export const containerStylesLG = mergeStyles([{
    width: '95dvw',
    height: 'calc(100dvh - 51px)',
    padding: '.875rem',
    position: 'absolute',
    top: '51px',
    left: '50%',
    transform: 'translateX(-50%)',
    fontFamily: 'Nunito',
    overflowY: 'auto'
}]);

export const containerStylesXL = mergeStyles([{
    width: '95dvw',
    height: 'calc(100dvh - 51px)',
    padding: '.875rem',
    position: 'absolute',
    top: '51px',
    left: '50%',
    transform: 'translateX(-50%)',
    fontFamily: 'Nunito',
    overflowY: 'auto'
}]);

export const containerStylesXXL = mergeStyles([{
    width: '95dvw',
    height: 'calc(100dvh - 51px)',
    padding: '.875rem',
    position: 'absolute',
    top: '51px',
    left: '50%',
    transform: 'translateX(-50%)',
    fontFamily: 'Nunito',
    overflowY: 'auto'
}]);

export const containerStylesXXXL = mergeStyles([{
    width: '70dvw',
    height: 'calc(100dvh - 51px)',
    padding: '.875rem',
    position: 'absolute',
    top: '51px',
    left: '50%',
    transform: 'translateX(-50%)',
    fontFamily: 'Nunito',
    overflowY: 'auto'
}]);

export const Container: React.FC = (props) => {
    const [breakpointsm] = useState<Breakpoint>(GetBreakpoint(BreakpointType.sm));
    const [breakpointmd] = useState<Breakpoint>(GetBreakpoint(BreakpointType.md));
    const [breakpointlg] = useState<Breakpoint>(GetBreakpoint(BreakpointType.lg));
    const [breakpointxl] = useState<Breakpoint>(GetBreakpoint(BreakpointType.xl));
    const [breakpointxxl] = useState<Breakpoint>(GetBreakpoint(BreakpointType.xxl));
    const [breakpointxxxl] = useState<Breakpoint>(GetBreakpoint(BreakpointType.xxxl));

    return (
        <>
            <MediaQuery minWidth={breakpointsm.minWidth} maxWidth={breakpointsm.maxWidth}>
                <Stack className={containerStylesSM}>
                    {props.children}
                </Stack>
            </MediaQuery>
            <MediaQuery minWidth={breakpointmd.minWidth} maxWidth={breakpointmd.maxWidth}>
                <Stack className={containerStylesMD}>
                    {props.children}
                </Stack>
            </MediaQuery>
            <MediaQuery minWidth={breakpointlg.minWidth} maxWidth={breakpointlg.maxWidth}>
                <Stack className={containerStylesLG}>
                    {props.children}
                </Stack>
            </MediaQuery>
            <MediaQuery minWidth={breakpointxl.minWidth} maxWidth={breakpointxl.maxWidth}>
                <Stack className={containerStylesXL}>
                    {props.children}
                </Stack>
            </MediaQuery>
            <MediaQuery minWidth={breakpointxxl.minWidth} maxWidth={breakpointxxl.maxWidth}>
                <Stack className={containerStylesXXL}>
                    {props.children}
                </Stack>
            </MediaQuery>
            <MediaQuery minWidth={breakpointxxxl.minWidth}>
                <Stack className={containerStylesXXXL}>
                    {props.children}
                </Stack>
            </MediaQuery>
        </>
    )
};